export const car_share = {
  namespaced: true,
  state: {
    car_share: {},
  },
  getters: {
    car_share(state) {
      return state.car_share;
    },
  },
  mutations: {
    setCarShare(state, info) {
      state.car_share = info;
    },
  },
  actions: {
    // カーシェア情報を緯度経度から取得
    async getCarShare(context, { geo }) {
      var params = {};
      const resp = await context.dispatch(
        "common/getRequest",
        {
          path: `search-car-share?geo_point=${geo}`,
          bodyParams: params,
        },
        { root: true }
      );
      console.log(
        "getCarShare resp.data.ResultSet.Point[0] :>> ",
        resp.data.ResultSet.Point[0]
      );
      return resp.data.ResultSet.Point[0];
    },
  },
};
